/**
 * Paleta de gradientes "futurista" usada nos badges de ícone, cards de
 * destaque e efeitos de vidro pelo sistema inteiro - deliberadamente sem
 * rosa/roxo (pedido explícito). Cada entrada tem o gradiente cheio (pra
 * fundo de badge) e o tom sólido "main" (pra sombra/glow tingido, texto,
 * borda no hover) derivado da mesma cor, pra tudo ficar consistente sem
 * precisar recalcular em cada componente que usa isso.
 */
export const gradients = {
    blue: { full: 'linear-gradient(135deg, #0A84FF 0%, #00D4FF 100%)', main: '#0A84FF' },
    teal: { full: 'linear-gradient(135deg, #00C896 0%, #00E5B0 100%)', main: '#00C896' },
    amber: { full: 'linear-gradient(135deg, #FF9F0A 0%, #FFD60A 100%)', main: '#FF9F0A' },
    coral: { full: 'linear-gradient(135deg, #FF6B4A 0%, #FF453A 100%)', main: '#FF453A' },
    graphite: { full: 'linear-gradient(135deg, #48484A 0%, #8E8E93 100%)', main: '#636366' }
};

export const gradientKeys = Object.keys(gradients);

/**
 * Estilo de "vidro" (glassmorphism) - painel translúcido com blur, usado
 * em cards que devem parecer flutuar sobre o fundo com camadas (o pedido
 * de "vidro transparente"/"camadas sobrepostas"). Função de `theme` pra
 * ajustar opacidade/borda automaticamente entre light/dark.
 */
export function glassPanel(theme) {
    const isDark = theme?.palette?.mode === 'dark';
    return {
        background: isDark ? 'rgba(30, 30, 47, 0.55)' : 'rgba(255, 255, 255, 0.65)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.6)'}`
    };
}
